import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';

/** Documentos de carga de cortes de SAP (evidencia de cada reemplazo). */
@Injectable({ providedIn: 'root' })
export class StockLoadsService extends ApiBaseService<any> {
  constructor() {
    super('stockloads');
  }
}
